import { render, staticRenderFns } from "./consumePriceAction.vue?vue&type=template&id=ad0f73c2&scoped=true"
import script from "./consumePriceAction.vue?vue&type=script&lang=js"
export * from "./consumePriceAction.vue?vue&type=script&lang=js"
import style0 from "./consumePriceAction.vue?vue&type=style&index=0&id=ad0f73c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad0f73c2",
  null
  
)

export default component.exports